// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

const Footer = ({ className, transparent }) => {
  const blockClass = cn({
    Footer: true,
    Footer_transparent: transparent,
    [`${className}`]: className,
  });
  return (
    <footer className={blockClass}>
      <div className="Footer__content">
        <div className="Footer__cell">
          <div className="Footer__logo" />
          <div className="Footer__label">
            &copy;&nbsp;
            {new Date().getFullYear()} Дмитрий Ершов,
            <br /> Олег Чулаков
          </div>
        </div>
        <div className="Footer__cell">
          <a className="Footer__link" href="mailto:dmitry.ershov@beztz.net">
            dmitry.ershov@beztz.net
          </a>
          <div className="Footer__label">По всем вопросам</div>
        </div>
        <div className="Footer__cell">
          <a className="Footer__link" href="http://tglink.ru/beztz_net" target="_blank">
            tglink.ru/beztz_net
          </a>
          <div className="Footer__label">Телеграм-канал с инсайтами</div>
        </div>
        <div className="Footer__cell">
          <a className="Footer__chulakov" href="https://chulakov.ru/" target="_blank">
            Сделано в Студии Олега Чулакова
          </a>
        </div>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  className: '',
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;



// WEBPACK FOOTER //
// components/Footer/index.js